import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";

type QuoteScopeClause = {
  requestForQuote: {
    bid:
      | { bidProject: { organizations: { some: { organizationId: string; deletedAt: null } } } }
      | { workSite: { homeownerId: string } };
  };
};

export const bidQuoteWhere = (user: User) => {
  if (hasCapability(user, "bidQuote.read.all")) {
    return {};
  }

  const clauses: QuoteScopeClause[] = [];

  if (hasCapability(user, "bidQuote.read.org")) {
    clauses.push({
      requestForQuote: {
        bid: {
          bidProject: {
            organizations: {
              some: {
                organizationId: user.person.organizationId,
                deletedAt: null,
              },
            },
          },
        },
      },
    });
  }
  if (hasCapability(user, "bidQuote.read.owned")) {
    clauses.push({ requestForQuote: { bid: { workSite: { homeownerId: user.person.id } } } });
  }

  if (clauses.length === 0) {
    return { AND: [{ id: NON_EXISTENT_ID }] };
  }
  return { OR: clauses };
};

export const quoteVersionWhere = (user: User) => {
  if (hasCapability(user, "quoteVersion.read.all")) {
    return {};
  }

  const clauses: QuoteScopeClause[] = [];

  if (hasCapability(user, "quoteVersion.read.org")) {
    clauses.push({
      requestForQuote: {
        bid: {
          bidProject: {
            organizations: {
              some: {
                organizationId: user.person.organizationId,
                deletedAt: null,
              },
            },
          },
        },
      },
    });
  }
  if (hasCapability(user, "quoteVersion.read.owned")) {
    clauses.push({ requestForQuote: { bid: { workSite: { homeownerId: user.person.id } } } });
  }

  if (clauses.length === 0) {
    return { AND: [{ id: NON_EXISTENT_ID }] };
  }
  return { OR: clauses };
};

export const quote = {
  applySalesDiscount: (user: User) => hasCapability(user, "quote.applySalesDiscount"),
  create: (user: User) => hasCapability(user, "quote.create"),
  read: (user: User) => hasCapability(user, "quote.read"),
  override: (user: User) => hasCapability(user, "quote.override"),
  createSalesAdjustment: (user: User) => hasCapability(user, "quote.createSalesAdjustment"),
  createNonSalesAdjustment: (user: User) => hasCapability(user, "quote.createNonSalesAdjustment"),
  createDealDeskDiscount: (user: User) => hasCapability(user, "quote.createDealDeskDiscount"),
  createPriceMatchDiscount: (user: User) => hasCapability(user, "quote.createPriceMatchDiscount"),
  createDealerFee: (user: User) => hasCapability(user, "quote.createDealerFee"),
  createWhenQuotingIsDisabled: (user: User) => hasCapability(user, "quote.createWhenQuotingIsDisabled"),
  approve: (user: User) => hasCapability(user, "quote.approve"),
};
